export default {
    cta: "Pergunte a um<br/> Conselheiro",
    ordered: "Encomendado em {date}"
}